module.exports = __webpack_public_path__ + "img/layout-desktop-mg.100bf477.png";